import { render } from "./TabsInspeccionComponent.vue?vue&type=template&id=11e6aee4&scoped=true"
import script from "./TabsInspeccionComponent.vue?vue&type=script&lang=js"
export * from "./TabsInspeccionComponent.vue?vue&type=script&lang=js"

import "./TabsInspeccionComponent.vue?vue&type=style&index=0&id=11e6aee4&scoped=true&lang=css"
import "./TabsInspeccionComponent.vue?vue&type=style&index=1&id=11e6aee4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e6aee4"]])

export default __exports__